import { render, staticRenderFns } from "./CalendarPeriod.vue?vue&type=template&id=1439a63a&"
import script from "./CalendarPeriod.vue?vue&type=script&lang=js&"
export * from "./CalendarPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports